const GoogleAnalytics = {
  install(Vue, options = {}) {
    window.tadaAnalyticsOptions = {
      ...options.tadaAnalyticsOptions,
    };

    window.tadaAnalyticsDataLayer = window.tadaAnalyticsDataLayer || [];

    // Normalize the hostname and page URL, so that embedded widgets still
    // all appear to come from primary URL (rather than whenever they're
    // actually embedded). Also normalize the page title, since this becomes
    // public on DAP's analytics.usa.gov page, and we don't want external
    // website titles to be used.
    let hostname;
    let rootPath;
    let title;
    // Base the normalization on the initial local settings that can be
    // determined from the initial page load, rather than the locale settings
    // that may change after determining the server-side locale via
    // loader.json (so don't use getters.localeCountry or
    // getters.localeLang). This is so that we always populate things in the
    // same way on the first page load and subsequent page loads, even if the
    // browser-detected locale might actually be different (eg, a French user
    // viewing an widget that defaults to English).
    if (options.store.getters.initialLocaleCountry === 'CA') {
      if (options.store.getters.initialLocaleLang === 'fr') {
        hostname = 'www.rncan.gc.ca';
        rootPath = '/energie/transports/personnel/20488';
        title = 'Localisateur de stations de recharge et de stations de ravitaillement en carburants de remplacement | Ressources naturelles Canada';
      } else {
        hostname = 'www.nrcan.gc.ca';
        rootPath = '/energy/transportation/personal/20487';
        title = 'Electric Charging and Alternative Fuelling Stations Locator | Natural Resources Canada';
      }
    } else {
      hostname = 'afdc.energy.gov';
      rootPath = '/stations/';
      title = 'Alternative Fuels Data Center: Alternative Fueling Station Locator';
    }

    // Since we use the hostname to determine which properties to report to, ensure
    // development/staging don't report to the production property.
    if (process.env.VUE_APP_ENV === 'staging') {
      hostname = 'afdc-stage.tada-stage.nrel.gov';
    } else if (process.env.VUE_APP_ENV !== 'production') {
      hostname = 'localhost';
    }

    // Set the real URL where this app is embedded at as a custom dimension.
    // Under this approach, all the embedded traffic will appear at our
    // primary URL, while embedded widget usage can be determined based on
    // filtering for this custom dimension.
    const loc = window.location;
    const realUrl = `${loc.protocol}//${loc.host}${loc.pathname}${loc.search}`;

    // Similarly, also set the real page title as a custom dimension for
    // widget traffic, where this may differ from our normalized value.
    const realTitle = document.title;

    window.tadaAnalyticsDataLayer.push({
      tadaWidgetOverrideBaseUrl: `https://${hostname}${rootPath}`,
      tadaWidgetOverrideTitle: title,
      tadaWidgetRealUrl: realUrl,
      tadaWidgetRealTitle: realTitle,
    });

    /* eslint-disable */
    // Google Tag Manager
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','tadaAnalyticsDataLayer','GTM-NVFRH9K');
    // End Google Tag Manager
    /* eslint-enable */

    /* eslint-disable */
    (function(){function q(w,n){w[n]=w[n]||function(){(w[n].q=w[n].q||[]).push(arguments)}};
    q(window,'tadaAnalyticsGa');q(window,'tadaAnalyticsGaAllTrackers')})();
    /* eslint-enable */

    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://widgets.nrel.gov/tada/analytics/analytics.js';
    const firstScript = document.getElementsByTagName('script')[0];
    firstScript.parentNode.insertBefore(script, firstScript);

    // A function for sending commands directly to the google analytics object.
    //
    // eslint-disable-next-line no-param-reassign, no-multi-assign
    Vue.prototype.$ga = Vue.$ga = function $ga(...args) {
      return window.tadaAnalyticsGa(...args);
    };

    // A function for sending commands to each one of the trackers.
    //
    // eslint-disable-next-line no-param-reassign, no-multi-assign
    Vue.prototype.$gaAllTrackers = Vue.$gaAllTrackers = function $gaAllTrackers(...args) {
      return window.tadaAnalyticsGaAllTrackers(...args);
    };

    // Add Vue router integration, so each route change gets sent to Google
    // Analytics.
    options.router.afterEach((to, from) => {
      // Skip analytics if the route hasn't actually changed.
      if (to.fullPath === from.fullPath) {
        const message = `Router navigation change to the same URL, this may lead to double counting of analytics. From: ${from.fullPath} To: ${to.fullPath}`;
        // eslint-disable-next-line no-console
        console.warn(message);
        Vue.$rollbar.warning(message);
        return;
      }

      Vue.$gaAllTrackers('set', 'hostname', hostname);
      Vue.$gaAllTrackers('set', 'page', `${rootPath}#${to.fullPath}`);
      Vue.$gaAllTrackers('set', 'title', title);
      Vue.$gaAllTrackers('set', 'dimension1', realUrl);
      Vue.$gaAllTrackers('set', 'dimension2', realTitle);

      Vue.$gaAllTrackers('send', 'pageview');
    });
  },
};

export default GoogleAnalytics;
